import { Flex, LinkBox, LinkOverlay, Stack, Text } from '@chakra-ui/react';

export default function GridCard ({ title, backgroundImage, href }) {
  return (
    <Stack>
      <LinkBox as='a'>
        <LinkOverlay href={href} isExternal>
          <Flex h="192px"
                w="350px"
                justify="center"
                align="center"
                bgImage={`linear-gradient(rgba(0, 0, 0, 0.4),rgba(0, 0, 0, 0.4)) , url(${backgroundImage})`}
                bgSize="cover"
                bgRepeat="no-repeat"
                borderRadius={10}
          >
            <Text
              whiteSpace="pre-line"
              align="center"
              color="white"
              fontWeight="bold"
              fontFamily="GerTT"
              fontSize="xl"
              opacity={1.0}>{title}</Text>
          </Flex>
        </LinkOverlay>
      </LinkBox>
    </Stack>
  );
};
